/** List all the main routes that user can navigate */
export let MainRoutes = /*#__PURE__*/function (MainRoutes) {
  /** The root page of the app which will be redirected to app route */
  MainRoutes["root"] = "/";
  /** The main page of the app */
  MainRoutes["app"] = "/:companyId";
  /** The projects page of the app */
  MainRoutes["projects"] = "projects";
  /** The members page of the app */
  MainRoutes["members"] = "users";
  /** The groups page of the app */
  MainRoutes["groups"] = "groups";
  /** The analytics page of the app */
  MainRoutes["analytics"] = "analytics";
  /** The workspace settings page of the app */
  MainRoutes["settings"] = "settings";
  /** The forbidding page due to lack of permissions of the app */
  MainRoutes["forbidden"] = "forbidden";
  /** Data Management page */
  MainRoutes["dataManagement"] = "data-management";
  /** The teams page */
  MainRoutes["teams"] = "teams";
  /** Account settings page */
  MainRoutes["accountSettings"] = "account";
  /** Add credits page */
  MainRoutes["credits"] = "tokens";
  /** Used to log out the user */
  MainRoutes["logout"] = "/logout";
  /** Used to handle subscription expiration and let user to start a new trial */
  MainRoutes["subscriptionExpired"] = "subscription-expired";
  return MainRoutes;
}({});

/** List all the sub-routes under credits */
export let CreditRoutes = /*#__PURE__*/function (CreditRoutes) {
  /** Route to handle redirection from stripe payment */
  CreditRoutes["purchaseSuccess"] = "purchase-success";
  return CreditRoutes;
}({});

/** List all the tabs for a specific project */
export let ProjectTabs = /*#__PURE__*/function (ProjectTabs) {
  /** The overview tab of a project */
  ProjectTabs["overview"] = "details";
  /** The team tab of a project */
  ProjectTabs["members"] = "members";
  /** The integrations tab of a project */
  ProjectTabs["integrations"] = "integrations";
  /** The Activity tab of a project */
  ProjectTabs["activity"] = "activity";
  /** The Settings tab of a project */
  ProjectTabs["settings"] = "settings";
  /** The annotations (markups included) tab of a project */
  ProjectTabs["annotations"] = "annotations";
  /** The Evaluations tab of a project */
  ProjectTabs["evaluation"] = "evaluation";
  /** The Snapshots tab of a project */
  ProjectTabs["snapshots"] = "snapshots";
  return ProjectTabs;
}({});

/** List all the tabs for a specific group */
export let GroupTabs = /*#__PURE__*/function (GroupTabs) {
  /** The Managers tab of a group */
  GroupTabs["managers"] = "members";
  /**
   * The Projects tab of a group
   * @deprecated Use activeProjects and archivedProjects instead. This route is kept for backward compatibility
   * to support all possible use cases, such as existing bookmarks or redirects from the old Dashboard.
   */
  GroupTabs["projects"] = "projects";
  /** The Active Projects tab of a group */
  GroupTabs["activeProjects"] = "active-projects";
  /** The Archived Projects tab of a group */
  GroupTabs["archivedProjects"] = "archived-projects";
  return GroupTabs;
}({});

/** List all the tabs for a specific member */
export let MemberTabs = /*#__PURE__*/function (MemberTabs) {
  /** The overview tab of a member */
  MemberTabs["overview"] = "profile";
  /** The teams tab of a member */
  MemberTabs["teams"] = "teams";
  return MemberTabs;
}({});
export let UsersTabs = /*#__PURE__*/function (UsersTabs) {
  /** The general tab of users page */
  UsersTabs["members"] = "members";
  /** The teams tab of settings page */
  UsersTabs["teams"] = "teams";
  return UsersTabs;
}({});
export let SettingsTabs = /*#__PURE__*/function (SettingsTabs) {
  /** The general tab of settings page */
  SettingsTabs["general"] = "general";
  /** The subscription tab of settings page */
  SettingsTabs["subscription"] = "subscription";
  /** The export tab of settings page */
  SettingsTabs["export"] = "export";
  return SettingsTabs;
}({});

/** List of tabs in account settings */
export let AccountSettingsTabs = /*#__PURE__*/function (AccountSettingsTabs) {
  /** The account and security tab of account settings */
  AccountSettingsTabs["security"] = "security";
  /** The preferences tab of account settings */
  AccountSettingsTabs["preferences"] = "preferences";
  /** The integrations account tab of account settings */
  AccountSettingsTabs["integrations"] = "integrations";
  /** The privacy account tab of account settings */
  AccountSettingsTabs["privacy"] = "privacy";
  return AccountSettingsTabs;
}({});

/** List all the tabs for analytics page */
export let AnalyticsTabs = /*#__PURE__*/function (AnalyticsTabs) {
  /** The workspace tab of analytics page */
  AnalyticsTabs["workspace"] = "workspace";
  /** The projects tab of analytics page */
  AnalyticsTabs["projects"] = "projects";
  /** The members tab of analytics page */
  AnalyticsTabs["members"] = "members";
  /** The groups tab of analytics page */
  AnalyticsTabs["groups"] = "groups";
  /** The in-house analytics tab (alpha) */
  AnalyticsTabs["inHouseAnalytics"] = "in-house-analytics";
  return AnalyticsTabs;
}({});

/** List all the tabs for team page */
export let TeamTabs = /*#__PURE__*/function (TeamTabs) {
  /** The overview tab of a team */
  TeamTabs["overview"] = "overview";
  /** The members tab of a team */
  TeamTabs["members"] = "members";
  return TeamTabs;
}({});

/** All the params to use with Router */

/** All the query search params that can be appended to the route */
export let QueryParams = /*#__PURE__*/function (QueryParams) {
  /** Company roles. Used to notify user about entering a forbidden page */
  QueryParams["workspaceRoles"] = "workspace_roles";
  /** Project permission. Used to notify user about entering a forbidden page */
  QueryParams["projectPermissions"] = "project_permissions";
  /** Company subscriptions. Used to notify user about entering a forbidden page */
  QueryParams["companySubscriptions"] = "company_subscriptions";
  /**
   * Original visited url. Used to redirect to the original page after user was redirected
   * to a forbidden page and it is no longer the case.
   */
  QueryParams["origin"] = "origin";
  /** User identity. Used to identify which user was notified about entering a forbidden page */
  QueryParams["user"] = "user";
  /** The language query */
  QueryParams["lang"] = "lang";
  /** The selected time frame */
  QueryParams["timeFrame"] = "time_frame";
  /** Enable all the feature flags */
  QueryParams["enableBeta"] = "enableBeta";
  /** Enable all the feature alpha */
  QueryParams["enableAlpha"] = "enableAlpha";
  /** Enable dev features */
  QueryParams["enableDev"] = "enableDev";
  /**
   * Hide migrated workspaces from Sphere Legacy.
   * TODO: Once https://faro01.atlassian.net/browse/ST-1652 is implemented we can remove this.
   */
  QueryParams["hideMigratedWorkspaces"] = "hideMigratedWorkspaces";
  /** Origin URL from where the account settings page were opened */
  QueryParams["settingsOriginUrl"] = "settingsOriginUrl";
  /** The current sort criteria */
  QueryParams["sortBy"] = "sortBy";
  /** Opens the Active Members dialog in Subscription Settings page. */
  QueryParams["activeMembers"] = "activeMembers";
  /** Allow sending new phrases to Localize from dev environments */
  QueryParams["allowTranslationOverride"] = "allowTranslationOverride";
  /** Enable sending errors to Sentry from numbered environments or localhost */
  QueryParams["enableSentry"] = "enableSentry";
  /** Enable sending product feedback to Teams from non-production environments or localhost */
  QueryParams["enableProductFeedback"] = "enableProductFeedback";
  /** The ID of a snapshot to open in the side panel */
  QueryParams["snapshotId"] = "snapshotId";
  /** Latitude of the world map camera position, used as a deep link to restore the map view */
  QueryParams["lat"] = "lat";
  /** Longitude of the world map camera position, used as a deep link to restore the map view */
  QueryParams["lng"] = "lng";
  /** Camera altitude (meters) of the world map, used as a deep link to restore the map view */
  QueryParams["alt"] = "alt";
  /** Camera heading (degrees) of the world map, used as a deep link to restore the map view */
  QueryParams["heading"] = "heading";
  /** Camera tilt (degrees) of the world map, used as a deep link to restore the map view */
  QueryParams["tilt"] = "tilt";
  return QueryParams;
}({});

/** List of all routes that were used by the deprecated HB Entry Page and still need to be supported */
export let HBEntryPageRoutes = /*#__PURE__*/function (HBEntryPageRoutes) {
  /** Route which was used in HB EntryPage to select a workspace */
  HBEntryPageRoutes["switchRoute"] = "/switch";
  /** Was used to allow the user to go to either COM or EU workspace page */
  HBEntryPageRoutes["serverSelectionRoute"] = "/server-selection";
  /** Was used to show a form to the user allowing them to request a trial */
  HBEntryPageRoutes["trialRequestRoute"] = "/trial-request";
  /** Was used to shows the user-module login prefilled with the sso-id */
  HBEntryPageRoutes["ssoRoute"] = "/sso/:ssoId";
  return HBEntryPageRoutes;
}({});

/** The route for HBD account settings page */
export const HBDSettingRoute = `/${MainRoutes.app}/me`;